// import Swiper from "swiper"

import { q } from "../../helper/q"
import { Swiper, Navigation } from "swiper/dist/js/swiper.esm.js"
Swiper.use([Navigation])
export let compareSlider = {}

export const compareSliderInit = () => {
  const sliderElement = q(".compareSlider")
  if (sliderElement)
    compareSlider = new Swiper(sliderElement, {
      slidesPerView: "auto",
      simulateTouch: false,
      navigation: {
        nextEl: ".compareSliderButtonNext",
        prevEl: ".compareSliderButtonPrev"
      }
    })
}
